import {SelectItem, SelectList, SelectPopover} from '@/components/ui/select-atoms/SelectAtoms'
import {StyledSelectTrigger} from '@/features/agenda/components/agenda-event-form/input-select-repeat-date/style'
import {RepetitionReturn} from '@/features/agenda/types'
import {generateRepetitionOptions} from '@/features/agenda/utils'
import {useTranslation} from '@/translations/i18n'
import {ObjectKeys, ObjectValues} from '@/utilities/helpers'
import {SelectProvider} from '@ariakit/react'

export const InputSelectRepeatDate = ({
    date,
    value,
    onChange
}: {
    date: Date
    value?: string
    onChange: (value: RepetitionReturn[keyof RepetitionReturn]) => void
}) => {
    const {t} = useTranslation()
    const repetitionOptions = generateRepetitionOptions(date, t)
    const valueObject = value ? ObjectValues(repetitionOptions).find(option => option?.value.id == value) : undefined

    return (
        <SelectProvider value={value}>
            <StyledSelectTrigger
                placeholder={t('commons:select')}
                value={value}
                displayValue={() => valueObject?.label}
            />
            <SelectPopover sameWidth={false}>
                <SelectList>
                    {ObjectKeys(repetitionOptions).map(key => (
                        <SelectItem
                            key={key}
                            value={repetitionOptions[key]?.value.id}
                            onClick={() => onChange(repetitionOptions[key])}
                        >
                            {repetitionOptions[key]?.label}
                        </SelectItem>
                    ))}
                </SelectList>
            </SelectPopover>
        </SelectProvider>
    )
}
